export enum APIResponseCodeEnum {
  user_error = 400,
  unauthorized = 401,
  already_exist = 403,
  not_found = 404,
  server_error = 500,
  refresh_token_error = 402
}
